export const SUPPORT_ASSISTANT_ROOT_ROUTE = '/support'

export const BOOKING_CONFIRMATION_PAGE_ROUTE = '/account/my-escapes/order'

// ContentTypes that should support the ability for orders to be listed
export const CONTENT_TYPES_LIST_ORDERS = [
  'list-orders',
  'list-flight-orders',
  'list-orders-with-airport-transfers',
  'list-orders-extra-guests',
]
